import type { AiJumpTarget } from "../../atoms/positionAtoms";

/** Whether a pane draws the finding locator ring for a jump: only on the pane
 * showing the target series, and only when the jump carries an in-plane
 * location to mark. */
export function showsFindingPulse(
  target: AiJumpTarget | null,
  seriesId: string | null | undefined,
): target is AiJumpTarget {
  return !!target && target.locate && target.seriesId === seriesId;
}
